import { palette } from '../theme';

/**
 * Full-screen connection status overlay with the acorn icon. Used:
 *   - "Connecting…"      while `conn.isActive` is false on first connect
 *   - "Reconnecting…"    during the brief unmount/remount window of the
 *                        reconnect-on-resume path (SessionGuard)
 *
 * Kept lightweight — no R3F, no STDB, just a centered icon + label.
 */
export function ConnectionStatusScreen({ label }: { label: string }) {
  return (
    <>
      <style>{`
        @keyframes acornPulse {
          0%, 100% { transform: scale(1); opacity: 0.85; }
          50%      { transform: scale(1.08); opacity: 1; }
        }
      `}</style>
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 18,
          background: palette.softSkyBlue,
          color: palette.barkBrown,
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <img
          src="/images/acorn.svg"
          alt=""
          width={84}
          height={84}
          style={{
            animation: 'acornPulse 1.6s ease-in-out infinite',
            filter: 'drop-shadow(0 4px 8px rgba(89, 62, 42, 0.25))',
          }}
        />
        <div style={{ fontSize: 14, opacity: 0.75, letterSpacing: 0.3 }}>
          {label}
        </div>
      </div>
    </>
  );
}
